import {all, fork ,call, put, takeEvery, takeLatest  } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import NetworkHandler from '../net/NetworkHandler'
import StorageHandler from '../storage/StorageHandler';
import * as ACTIONS from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateMailbox} from '../containers/Mailbox/actions';
import { createCipher } from 'crypto';
const storageHandler = new StorageHandler();


function* getMailbox(action){

  const Network = new NetworkHandler();
  
    try{

      const response = yield Network.requestGetMailbox(action.payload);
      
      if (!(response instanceof Error)) {
          yield put(
              updateMailbox(
                response
              )
            );
			
			//console.log(response);
        } else {
          yield put(
            error({
              message: `Unable to get mailbox. ${response}`,
            })
          );
        }
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to load mailbox, please try again.${errorMsg}`,
            })
        );
    }
}

function* updateMailboxInvite(action){

  //console.log("Update mailbox invite status");

  const Network = new NetworkHandler();
  
    try{

      const response = yield Network.requestUpdateMailboxInvite(action.payload);
      
      if (!(response instanceof Error)) {
          //console.log("Mailbox Invite Updated")
        } else {
          yield put(
            error({
              message: `Unable to get mailbox. ${response}`,
            })
          );
        }
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to load mailbox, please try again.${errorMsg}`,
            })
        );
    }
}

export default function* usersSagas() {
  yield takeLatest(ACTIONS.MAILBOX_GET, getMailbox);
  yield takeLatest(ACTIONS.MAILBOX_UPDATE_INVITE, updateMailboxInvite);
  
}

